import { render, staticRenderFns } from "./HomeSlider.vue?vue&type=template&id=c19f196c&scoped=true&"
import script from "./HomeSlider.vue?vue&type=script&lang=js&"
export * from "./HomeSlider.vue?vue&type=script&lang=js&"
import style0 from "./HomeSlider.vue?vue&type=style&index=0&id=c19f196c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19f196c",
  null
  
)

export default component.exports